"use client";

import React from "react";
import { cn } from "@/lib/utils";
import {
    getSignInMarketingContent,
    type MechanismRow,
} from "./sign-in-marketing-content";

interface SignInMarketingPanelProps {
    slug?: string;
    className?: string;
}

const SignInMarketingPanel: React.FC<SignInMarketingPanelProps> = ({
    slug,
    className,
}) => {
    const content = getSignInMarketingContent(slug);

    return (
        <div
            className={cn(
                "flex h-full flex-col justify-center gap-6 px-6 py-8 sm:px-8 sm:py-10 lg:px-10 lg:py-12",
                className,
            )}
        >
            <div className="space-y-3">
                <p className="text-overline text-primary">{content.eyebrow}</p>
                <h2 className="text-title-lg max-w-md text-balance text-foreground">
                    {content.headline}
                </h2>
                {content.subhead ? (
                    <p className="text-body max-w-md text-balance text-muted-foreground">
                        {content.subhead}
                    </p>
                ) : null}
            </div>

            <div className="border-t border-border" />

            <ul className="flex flex-col gap-5">
                {content.mechanism.map((row, idx) => (
                    <MechanismItem key={idx} row={row} />
                ))}
            </ul>
        </div>
    );
};

const MechanismItem: React.FC<{ row: MechanismRow }> = ({ row }) => {
    const Icon = row.icon;
    return (
        <li className="flex items-start gap-3.5">
            <span
                className="flex h-9 w-9 shrink-0 items-center justify-center border border-primary/30 bg-primary/5 text-primary"
                aria-hidden
            >
                <Icon className="h-4 w-4" />
            </span>
            <div className="min-w-0 flex-1 pt-0.5">
                <p className="text-title-sm text-foreground">{row.title}</p>
                <p className="text-body-sm text-muted-foreground">{row.body}</p>
            </div>
        </li>
    );
};

export default SignInMarketingPanel;
